module.exports = __webpack_public_path__ + "img/como_funciona.18219a44.png";